exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2uAr{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_2uAr",
	"root": "_2uAr"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/ShareSocial/ShareSocial.css
// module id = 257
// module chunks = 0